unit uRegEntEmp;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, WEBLib.Calendar;

type
  TFRegEntEmp = class(TForm)
    WebPanel1: TPanel;
    WebLabel2: TLabel;
    WebLabel1: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebLabel7: TLabel;
    WebLabel8: TLabel;
    WebPanel2: TPanel;
    WebLabel9: TLabel;
    WebSpeedButton1: TSpeedButton;
    WebCalendar1: TCalendar;
    CEntrenaDoc: TClientConnection;
    TEntrenaDoc: TClientDataSet;
    DsEntrenaDoc: TDataSource;
    WebPanel3: TPanel;
    WebDBGrid2: TDBGrid;
    WebEdit2: TEdit;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    CEntrenamientos: TClientConnection;
    TEntrenamientos: TClientDataSet;
    DsEntrenamientos: TDataSource;
    WebEdit3: TEdit;
    WebEdit4: TEdit;
    WebEdit5: TEdit;
    WebEdit6: TEdit;
    WebEdit7: TEdit;
    WebEdit8: TEdit;
    WebEdit9: TEdit;
    WebDateTimePicker1: TDateTimePicker;
    WebCheckBox1: TCheckBox;
    CEmpleados: TClientConnection;
    TEmpleados: TClientDataSet;
    WebHttpRequest1: THttpRequest;
    WebSpeedButton10: TSpeedButton;
    WebPanel5: TPanel;
    WebLabel11: TLabel;
    WebDBGrid4: TDBGrid;
    WebEdit10: TEdit;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton12: TSpeedButton;
    DsEmpleados: TDataSource;
    WebPanel4: TPanel;
    WebListBox1: TListBox;
    WebPanel6: TPanel;
    WebDBGrid1: TDBGrid;
    WebEdit1: TEdit;
    CEntrenamientosPT: TClientConnection;
    TEntrenamientosPT: TClientDataSet;
    DsEntrenamientosPT: TDataSource;
    WebButton1: TButton;
    CEmpPT: TClientConnection;
    TEmPT: TClientDataSet;
    WebButton2: TButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebDBGrid2DblClick(Sender: TObject);
    procedure WebDBEdit1Enter(Sender: TObject);
    procedure CEntrenamientosDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebEdit3Enter(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebHttpRequest1Response(Sender: TObject; AResponse: string);
    procedure CEntrenaDocDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebDBGrid4DblClick(Sender: TObject);
    procedure WebSpeedButton12Click(Sender: TObject);
    procedure WebCalendar1DateSelected(Sender: TObject; ADate: TDateTime);
    procedure CEntrenamientosPTAfterConnect(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure CEmpPTAfterConnect(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

type
  TProcedureRef = reference to procedure;

var
  FRegEntEmp: TFRegEntEmp;
  DeptoDes, PuestoDes : String;

implementation

{$R *.dfm}

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFRegEntEmp.CEmpPTAfterConnect(Sender: TObject);
begin
WebEdit1.Text:=TEmPT.FieldByName('Numero').AsString+' - '+
TEmPT.FieldByName('Nombre').AsString;
end;

procedure TFRegEntEmp.CEntrenaDocDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
WebSpeedButton6.Visible:=True;
end;

procedure TFRegEntEmp.CEntrenamientosDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
  // TEntrenamientos.Insert;
end;

procedure TFRegEntEmp.CEntrenamientosPTAfterConnect(Sender: TObject);
begin
WebPanel6.Visible:=True;
end;

procedure TFRegEntEmp.WebButton1Click(Sender: TObject);
begin
CEntrenamientosPT.Active := False;
CEmpPT.Active := False;

  if WebListBox1.ItemIndex <> -1 then
  begin
    CEmpPT.Command := httpGET;
    CEmpPT.URI := 'http://207.244.241.82:9000/Empleados?Numero=' +
      WebListBox1.Items[WebListBox1.ItemIndex];
    CEmpPT.Active := True;
    CEntrenamientosPT.Command := httpGET;
    CEntrenamientosPT.URI := 'http://207.244.241.82:9000/Entrenamientos?Numero='
      + WebListBox1.Items[WebListBox1.ItemIndex];
    CEntrenamientosPT.Active := True;
  end;
end;

procedure TFRegEntEmp.WebButton2Click(Sender: TObject);
var
  Data: TJSONObject;
begin
Data := TJSONObject.Create;
  try
    Data.AddPair('Registro', TEntrenamientosPT.FieldByName('Registro').AsString);

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/Entrenamientos';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpDELETE;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
  SleepAsync(300,
    procedure
    begin
      TEntrenamientosPT.Refresh;
    end);
ShowMessage('Registro eliminado!!');
end;

procedure TFRegEntEmp.WebCalendar1DateSelected(Sender: TObject;
  ADate: TDateTime);
begin
WebDateTimePicker1.Date := WebCalendar1.SelectedDate;
end;

procedure TFRegEntEmp.WebDBEdit1Enter(Sender: TObject);
begin
  WebPanel3.Visible := True;
end;

procedure TFRegEntEmp.WebDBGrid2DblClick(Sender: TObject);
begin
  WebEdit3.Text := TEntrenaDoc.FieldByName('Codigo').AsString;
  WebEdit4.Text := TEntrenaDoc.FieldByName('Revision').AsString;
  WebEdit8.Text := TEntrenaDoc.FieldByName('DuracionH').AsString;
  WebEdit9.Text := TEntrenaDoc.FieldByName('DuracionM').AsString;
  WebPanel3.Visible := False;
end;

procedure TFRegEntEmp.WebDBGrid4DblClick(Sender: TObject);
var
  Data: TJSONObject;
begin
  if (WebEdit3.Text = '') or (WebEdit4.Text = '') or (WebEdit5.Text = '') or
    (WebEdit6.Text = '') then
  begin
    ShowMessage
      ('La información correspondiente al entrenamiento que se desea asignar no se encuentra debidamente completa.'
      + sLineBreak +
      'Favor de verificar y corregir los datos antes de continuar.');
    Exit;
    WebPanel5.Visible:=False;
  end;
  Data := TJSONObject.Create;
  try
    Data.AddPair('Numero', TEmpleados.FieldByName('Numero').AsString);
    Data.AddPair('Nombre', TEmpleados.FieldByName('Nombre').AsString);
    Data.AddPair('Documento', TEntrenaDoc.FieldByName('Codigo').AsString);
    Data.AddPair('DocumentoDes', TEntrenaDoc.FieldByName('Descripcion')
      .AsString);
    Data.AddPair('Fecha', FormatDateTime('MM/DD/YYYY',
      WebDateTimePicker1.Date));
    Data.AddPair('Revision', TEntrenaDoc.FieldByName('Revision').AsString);
    Data.AddPair('Puesto', TEmpleados.FieldByName('Puesto').AsString);
    Data.AddPair('PuestoDes', '');
    Data.AddPair('Depto', TEmpleados.FieldByName('Depto').AsString);
    Data.AddPair('DeptoDes', '');
    Data.AddPair('Sala', WebEdit6.Text);
    Data.AddPair('DuracionH', WebEdit8.Text);
    Data.AddPair('DuracionM', WebEdit9.Text);
    Data.AddPair('Entrenador', WebEdit5.Text);
    Data.AddPair('DocNum', TEntrenaDoc.FieldByName('Codigo').AsString);
    Data.AddPair('Folio', WebEdit7.Text);
    Data.AddPair('Folio2', '');
    Data.AddPair('Externo', 'False');
    if WebCheckBox1.Checked = True then
    begin
      Data.AddPair('Externo', 'True');
    end;

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/Entrenamientos';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
WebPanel5.Visible:=False;
end;


procedure TFRegEntEmp.WebEdit3Enter(Sender: TObject);
begin
  WebPanel3.Visible := True;
end;

procedure TFRegEntEmp.WebFormCreate(Sender: TObject);
begin
  CEntrenaDoc.Command := httpGET;
  CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc';
  CEntrenaDoc.Active := True;
  CEntrenamientos.Command := httpGET;
  CEntrenamientos.URI := 'http://207.244.241.82:9000/Entrenamientos';
  CEntrenamientos.Active := True;

  WebPanel3.Left := 24;
  WebPanel3.Top := 33;
  WebDateTimePicker1.Date:=Now;
end;

procedure TFRegEntEmp.WebHttpRequest1Response(Sender: TObject;
  AResponse: string);
begin
if AResponse = 'Entrenamientos insertado correctamente' then
  begin
  ShowMessage('Entrenamiento registrado correctamente!!!');
  //FRegEntEmp.Hide;
  WebListBox1.Items.Add(TEmpleados.FieldByName('Numero').AsString);
  end;
if AResponse = 'Entrenamientos duplicados' then
  begin
  ShowMessage(AResponse);
  end;
if AResponse = 'Error Entrenamientos no registrados' then
  begin
  ShowMessage(AResponse);
  end;
end;

procedure TFRegEntEmp.WebSpeedButton10Click(Sender: TObject);
begin
FRegEntEmp.Hide;
end;

procedure TFRegEntEmp.WebSpeedButton12Click(Sender: TObject);
begin
WebPanel5.Visible:=False;
end;

procedure TFRegEntEmp.WebSpeedButton1Click(Sender: TObject);

begin
{  if (WebEdit3.Text = '') or (WebEdit4.Text = '') or (WebEdit5.Text = '') or
    (WebEdit6.Text = '') then
  begin
    ShowMessage
      ('La información correspondiente al entrenamiento que se desea asignar no se encuentra debidamente completa.'
      + sLineBreak +
      'Favor de verificar y corregir los datos antes de continuar.');
      Exit;
  end;
Data := TJSONObject.Create;
  try
    Data.AddPair('Numero', TEmpleados.FieldByName('Numero').AsString);
    Data.AddPair('Nombre', TEmpleados.FieldByName('Nombre').AsString);
    Data.AddPair('Documento', TEntrenaDoc.FieldByName('Codigo').AsString);
    Data.AddPair('DocumentoDes', TEntrenaDoc.FieldByName('Descripcion').AsString);
    Data.AddPair('Fecha', FormatDateTime('MM/DD/YYYY', WebDateTimePicker1.Date));
    Data.AddPair('Revision', TEntrenaDoc.FieldByName('Revision').AsString);
    Data.AddPair('Puesto', TEmpleados.FieldByName('Puesto').AsString);
    Data.AddPair('PuestoDes', '');
    Data.AddPair('Depto', TEmpleados.FieldByName('Depto').AsString);
    Data.AddPair('DeptoDes', '');
    Data.AddPair('Sala', WebEdit6.Text);
    Data.AddPair('DuracionH', WebEdit8.Text);
    Data.AddPair('DuracionM', WebEdit9.Text);
    Data.AddPair('Entrenador', WebEdit5.Text);
    Data.AddPair('DocNum', TEntrenaDoc.FieldByName('Codigo').AsString);
    Data.AddPair('Folio', WebEdit7.Text);
    Data.AddPair('Folio2', '');
    Data.AddPair('Externo', 'False');
    if WebCheckBox1.Checked = True then
      begin
      Data.AddPair('Externo', 'True');
      end;

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/Entrenamientos';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpPOST;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
  }
WebPanel5.Visible:=True;
WebPanel5.Top:=  52;
WebPanel5.Left:= 186;
end;

procedure TFRegEntEmp.WebSpeedButton5Click(Sender: TObject);
begin
  WebPanel3.Visible := False;
end;

procedure TFRegEntEmp.WebSpeedButton6Click(Sender: TObject);
begin
if not TEntrenaDoc.Locate('Codigo', WebEdit2.Text, []) Then
  begin
  ShowMessage('ERROR, NO EXISTE EL DOCUMENTO: '+WebEdit2.Text);
  end;
end;

procedure TFRegEntEmp.WebSpeedButton7Click(Sender: TObject);
begin
CEmpleados.Command := httpGET;
  CEmpleados.URI := 'http://207.244.241.82:9000/Empleados?Busqueda=' +
    WebEdit10.Text;
  CEmpleados.Active := True;

//  WebLabel10.Caption:='BUSCANDO EMPLEADO...';
  //WebLabel10.Visible := False;
 // CEmpleados.Command := httpGET;
 // CEmpleados.URI := 'http://207.244.241.82:9000/Empleados?Numero=' +
  //  WebEdit1.Text;
 // CEmpleados.Active := True;
end;

procedure TFRegEntEmp.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel6 := TPanel.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebListBox1 := TListBox.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebEdit7 := TEdit.Create(Self);
  WebEdit8 := TEdit.Create(Self);
  WebEdit9 := TEdit.Create(Self);
  WebDateTimePicker1 := TDateTimePicker.Create(Self);
  WebCheckBox1 := TCheckBox.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebCalendar1 := TCalendar.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  WebDBGrid4 := TDBGrid.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton12 := TSpeedButton.Create(Self);
  CEntrenaDoc := TClientConnection.Create(Self);
  TEntrenaDoc := TClientDataSet.Create(Self);
  DsEntrenaDoc := TDataSource.Create(Self);
  CEntrenamientos := TClientConnection.Create(Self);
  TEntrenamientos := TClientDataSet.Create(Self);
  DsEntrenamientos := TDataSource.Create(Self);
  CEmpleados := TClientConnection.Create(Self);
  TEmpleados := TClientDataSet.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  DsEmpleados := TDataSource.Create(Self);
  CEntrenamientosPT := TClientConnection.Create(Self);
  TEntrenamientosPT := TClientDataSet.Create(Self);
  DsEntrenamientosPT := TDataSource.Create(Self);
  CEmpPT := TClientConnection.Create(Self);
  TEmPT := TClientDataSet.Create(Self);

  WebPanel6.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebListBox1.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebEdit7.BeforeLoadDFMValues;
  WebEdit8.BeforeLoadDFMValues;
  WebEdit9.BeforeLoadDFMValues;
  WebDateTimePicker1.BeforeLoadDFMValues;
  WebCheckBox1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebCalendar1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  WebDBGrid4.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton12.BeforeLoadDFMValues;
  CEntrenaDoc.BeforeLoadDFMValues;
  TEntrenaDoc.BeforeLoadDFMValues;
  DsEntrenaDoc.BeforeLoadDFMValues;
  CEntrenamientos.BeforeLoadDFMValues;
  TEntrenamientos.BeforeLoadDFMValues;
  DsEntrenamientos.BeforeLoadDFMValues;
  CEmpleados.BeforeLoadDFMValues;
  TEmpleados.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  DsEmpleados.BeforeLoadDFMValues;
  CEntrenamientosPT.BeforeLoadDFMValues;
  TEntrenamientosPT.BeforeLoadDFMValues;
  DsEntrenamientosPT.BeforeLoadDFMValues;
  CEmpPT.BeforeLoadDFMValues;
  TEmPT.BeforeLoadDFMValues;
  try
    Name := 'FRegEntEmp';
    Width := 1658;
    Height := 909;
    Caption := 'Registra entrenamiento a empleados';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebPanel6.SetParentComponent(Self);
    WebPanel6.Name := 'WebPanel6';
    WebPanel6.Left := 574;
    WebPanel6.Top := 17;
    WebPanel6.Width := 563;
    WebPanel6.Height := 688;
    WebPanel6.HeightPercent := 100.000000000000000000;
    WebPanel6.WidthPercent := 100.000000000000000000;
    WebPanel6.BorderColor := clSilver;
    WebPanel6.BorderStyle := bsSingle;
    WebPanel6.ChildOrder := 8;
    WebPanel6.Color := clMoneyGreen;
    WebPanel6.Visible := False;
    WebDBGrid1.SetParentComponent(WebPanel6);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 30;
    WebDBGrid1.Top := 50;
    WebDBGrid1.Width := 515;
    WebDBGrid1.Height := 591;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Numero';
      Title := 'Numero';
      Width := 150;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Documento';
      Title := 'Documento';
      Width := 250;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'DocumentoDes';
      Title := 'Desc.';
      Width := 100;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Fecha';
      Title := 'Fecha';
      Width := 100;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Revision';
      Title := 'Rev.';
    end;
    WebDBGrid1.DataSource := DsEntrenamientosPT;
    WebDBGrid1.FixedCols := 0;
    WebDBGrid1.TabOrder := 0;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 150;
    WebDBGrid1.ColWidths[1] := 250;
    WebDBGrid1.ColWidths[2] := 100;
    WebDBGrid1.ColWidths[3] := 100;
    WebDBGrid1.ColWidths[4] := 64;
    WebDBGrid1.RowHeights[0] := 22;
    WebDBGrid1.RowHeights[1] := 22;
    WebDBGrid1.RowHeights[2] := 22;
    WebDBGrid1.RowHeights[3] := 22;
    WebDBGrid1.RowHeights[4] := 22;
    WebEdit1.SetParentComponent(WebPanel6);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 30;
    WebEdit1.Top := 22;
    WebEdit1.Width := 419;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 4;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.ReadOnly := True;
    WebEdit1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel6);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 30;
    WebButton2.Top := 647;
    WebButton2.Width := 96;
    WebButton2.Height := 26;
    WebButton2.Caption := 'Borrar';
    WebButton2.ChildOrder := 2;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 351;
    WebPanel4.Top := 119;
    WebPanel4.Width := 210;
    WebPanel4.Height := 315;
    WebPanel4.HeightPercent := 100.000000000000000000;
    WebPanel4.WidthPercent := 100.000000000000000000;
    WebPanel4.BorderColor := clBlack;
    WebPanel4.BorderStyle := bsSingle;
    WebPanel4.ChildOrder := 1;
    WebPanel4.Color := clInfoBk;
    WebListBox1.SetParentComponent(WebPanel4);
    WebListBox1.Name := 'WebListBox1';
    WebListBox1.Left := 16;
    WebListBox1.Top := 18;
    WebListBox1.Width := 177;
    WebListBox1.Height := 255;
    WebListBox1.Font.Charset := DEFAULT_CHARSET;
    WebListBox1.Font.Color := clWindowText;
    WebListBox1.Font.Height := -19;
    WebListBox1.Font.Name := 'Tahoma';
    WebListBox1.Font.Style := [fsBold,fsUnderline];
    WebListBox1.HeightPercent := 100.000000000000000000;
    WebListBox1.ItemHeight := 23;
    WebListBox1.ItemIndex := -1;
    WebListBox1.ParentFont := False;
    WebListBox1.WidthPercent := 100.000000000000000000;
    WebButton1.SetParentComponent(WebPanel4);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 16;
    WebButton1.Top := 279;
    WebButton1.Width := 177;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Ver entrenamientos';
    WebButton1.ChildOrder := 1;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 17;
    WebPanel1.Width := 337;
    WebPanel1.Height := 417;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.Color := clInfoBk;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 16;
    WebLabel2.Width := 58;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Documento:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 63;
    WebLabel1.Width := 44;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Revisi'#243'n:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 110;
    WebLabel3.Width := 115;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Nombre del entrenador:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel1);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 157;
    WebLabel4.Width := 121;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Fecha de entrenamiento:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel1);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 16;
    WebLabel5.Top := 204;
    WebLabel5.Width := 112;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Sala de entrenamiento:';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel1);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 16;
    WebLabel6.Top := 251;
    WebLabel6.Width := 26;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Folio:';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebLabel7.SetParentComponent(WebPanel1);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 16;
    WebLabel7.Top := 298;
    WebLabel7.Width := 32;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Horas:';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebLabel8.SetParentComponent(WebPanel1);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 87;
    WebLabel8.Top := 298;
    WebLabel8.Width := 41;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Minutos:';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebEdit3.SetParentComponent(WebPanel1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 16;
    WebEdit3.Top := 35;
    WebEdit3.Width := 193;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 17;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit3, Self, 'OnEnter', 'WebEdit3Enter');
    WebEdit4.SetParentComponent(WebPanel1);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 16;
    WebEdit4.Top := 82;
    WebEdit4.Width := 193;
    WebEdit4.Height := 22;
    WebEdit4.ChildOrder := 17;
    WebEdit4.HeightPercent := 100.000000000000000000;
    WebEdit4.WidthPercent := 100.000000000000000000;
    WebEdit5.SetParentComponent(WebPanel1);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 16;
    WebEdit5.Top := 129;
    WebEdit5.Width := 193;
    WebEdit5.Height := 22;
    WebEdit5.ChildOrder := 17;
    WebEdit5.HeightPercent := 100.000000000000000000;
    WebEdit5.WidthPercent := 100.000000000000000000;
    WebEdit6.SetParentComponent(WebPanel1);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 16;
    WebEdit6.Top := 223;
    WebEdit6.Width := 193;
    WebEdit6.Height := 22;
    WebEdit6.ChildOrder := 17;
    WebEdit6.HeightPercent := 100.000000000000000000;
    WebEdit6.WidthPercent := 100.000000000000000000;
    WebEdit7.SetParentComponent(WebPanel1);
    WebEdit7.Name := 'WebEdit7';
    WebEdit7.Left := 16;
    WebEdit7.Top := 270;
    WebEdit7.Width := 112;
    WebEdit7.Height := 22;
    WebEdit7.ChildOrder := 17;
    WebEdit7.HeightPercent := 100.000000000000000000;
    WebEdit7.WidthPercent := 100.000000000000000000;
    WebEdit8.SetParentComponent(WebPanel1);
    WebEdit8.Name := 'WebEdit8';
    WebEdit8.Left := 16;
    WebEdit8.Top := 317;
    WebEdit8.Width := 44;
    WebEdit8.Height := 22;
    WebEdit8.ChildOrder := 17;
    WebEdit8.HeightPercent := 100.000000000000000000;
    WebEdit8.WidthPercent := 100.000000000000000000;
    WebEdit9.SetParentComponent(WebPanel1);
    WebEdit9.Name := 'WebEdit9';
    WebEdit9.Left := 84;
    WebEdit9.Top := 317;
    WebEdit9.Width := 44;
    WebEdit9.Height := 22;
    WebEdit9.ChildOrder := 17;
    WebEdit9.HeightPercent := 100.000000000000000000;
    WebEdit9.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.SetParentComponent(WebPanel1);
    WebDateTimePicker1.Name := 'WebDateTimePicker1';
    WebDateTimePicker1.Left := 16;
    WebDateTimePicker1.Top := 176;
    WebDateTimePicker1.Width := 193;
    WebDateTimePicker1.Height := 22;
    WebDateTimePicker1.HeightPercent := 100.000000000000000000;
    WebDateTimePicker1.WidthPercent := 100.000000000000000000;
    WebDateTimePicker1.BorderStyle := bsSingle;
    WebDateTimePicker1.ChildOrder := 17;
    WebDateTimePicker1.Color := clWhite;
    WebDateTimePicker1.Date := 46009.634871087960000000;
    WebDateTimePicker1.Role := '';
    WebDateTimePicker1.Text := '';
    WebCheckBox1.SetParentComponent(WebPanel1);
    WebCheckBox1.Name := 'WebCheckBox1';
    WebCheckBox1.Left := 18;
    WebCheckBox1.Top := 360;
    WebCheckBox1.Width := 191;
    WebCheckBox1.Height := 22;
    WebCheckBox1.Caption := 'Entrenamiento externo';
    WebCheckBox1.ChildOrder := 16;
    WebCheckBox1.Color := clNone;
    WebCheckBox1.HeightPercent := 100.000000000000000000;
    WebCheckBox1.State := cbUnchecked;
    WebCheckBox1.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 351;
    WebPanel2.Top := 17;
    WebPanel2.Width := 210;
    WebPanel2.Height := 96;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clBlack;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.ChildOrder := 1;
    WebPanel2.Color := clInfoBk;
    WebLabel9.SetParentComponent(WebPanel2);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 11;
    WebLabel9.Top := 16;
    WebLabel9.Width := 70;
    WebLabel9.Height := 13;
    WebLabel9.Caption := 'No. empleado:';
    WebLabel9.HeightPercent := 100.000000000000000000;
    WebLabel9.WidthPercent := 100.000000000000000000;
    WebSpeedButton1.SetParentComponent(WebPanel2);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 11;
    WebSpeedButton1.Top := 35;
    WebSpeedButton1.Width := 166;
    WebSpeedButton1.Height := 24;
    WebSpeedButton1.Caption := '    Asignar empleado';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('uRegEntEmp.WebPanel2.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebCalendar1.SetParentComponent(Self);
    WebCalendar1.Name := 'WebCalendar1';
    WebCalendar1.Left := 8;
    WebCalendar1.Top := 455;
    WebCalendar1.Width := 449;
    WebCalendar1.Height := 250;
    WebCalendar1.HeightPercent := 100.000000000000000000;
    WebCalendar1.WidthPercent := 100.000000000000000000;
    WebCalendar1.ChildOrder := 2;
    WebCalendar1.TabOrder := 2;
    WebCalendar1.SelectedDate := 45992.000000000000000000;
    WebCalendar1.Year := 2025;
    WebCalendar1.Month := 12;
    WebCalendar1.Day := 1;
    WebCalendar1.NameOfMonths.January := 'January';
    WebCalendar1.NameOfMonths.February := 'February';
    WebCalendar1.NameOfMonths.March := 'March';
    WebCalendar1.NameOfMonths.April := 'April';
    WebCalendar1.NameOfMonths.May := 'May';
    WebCalendar1.NameOfMonths.June := 'June';
    WebCalendar1.NameOfMonths.July := 'July';
    WebCalendar1.NameOfMonths.August := 'August';
    WebCalendar1.NameOfMonths.September := 'September';
    WebCalendar1.NameOfMonths.October := 'October';
    WebCalendar1.NameOfMonths.November := 'November';
    WebCalendar1.NameOfMonths.December := 'December';
    WebCalendar1.NameOfDays.Sunday := 'Sun';
    WebCalendar1.NameOfDays.Monday := 'Mon';
    WebCalendar1.NameOfDays.Tuesday := 'Tue';
    WebCalendar1.NameOfDays.Wednesday := 'Wed';
    WebCalendar1.NameOfDays.Thursday := 'Thu';
    WebCalendar1.NameOfDays.Friday := 'Fri';
    WebCalendar1.NameOfDays.Saturday := 'Sat';
    SetEvent(WebCalendar1, Self, 'OnDateSelected', 'WebCalendar1DateSelected');
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 26;
    WebPanel3.Top := 730;
    WebPanel3.Width := 501;
    WebPanel3.Height := 351;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clBlack;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 7;
    WebPanel3.Color := 15389113;
    WebPanel3.Visible := False;
    WebDBGrid2.SetParentComponent(WebPanel3);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 16;
    WebDBGrid2.Top := 47;
    WebDBGrid2.Width := 465;
    WebDBGrid2.Height := 282;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Codigo';
      Title := 'C'#243'digo';
      Width := 140;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Descripcion';
      Title := 'Descripci'#243'n';
      Width := 260;
    end;
    WebDBGrid2.DataSource := DsEntrenaDoc;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.TabOrder := 0;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid2, Self, 'OnDblClick', 'WebDBGrid2DblClick');
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 140;
    WebDBGrid2.ColWidths[2] := 260;
    WebEdit2.SetParentComponent(WebPanel3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 16;
    WebEdit2.Top := 19;
    WebEdit2.Width := 121;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 1;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 151;
    WebSpeedButton6.Top := 17;
    WebSpeedButton6.Width := 100;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := 'Buscar';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('uRegEntEmp.WebPanel3.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.Visible := False;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton5.SetParentComponent(WebPanel3);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 269;
    WebSpeedButton5.Top := 17;
    WebSpeedButton5.Width := 100;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Caption := 'Cancelar';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uRegEntEmp.WebPanel3.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 1163;
    WebSpeedButton10.Top := 17;
    WebSpeedButton10.Width := 81;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uRegEntEmp.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebPanel5.SetParentComponent(Self);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 557;
    WebPanel5.Top := 730;
    WebPanel5.Width := 703;
    WebPanel5.Height := 326;
    WebPanel5.HeightPercent := 100.000000000000000000;
    WebPanel5.WidthPercent := 100.000000000000000000;
    WebPanel5.BorderColor := clSilver;
    WebPanel5.BorderStyle := bsSingle;
    WebPanel5.ChildOrder := 8;
    WebPanel5.Color := clSkyBlue;
    WebPanel5.Visible := False;
    WebLabel11.SetParentComponent(WebPanel5);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 30;
    WebLabel11.Top := 27;
    WebLabel11.Width := 81;
    WebLabel11.Height := 13;
    WebLabel11.Caption := 'Busca empleado:';
    WebLabel11.HeightPercent := 100.000000000000000000;
    WebLabel11.WidthPercent := 100.000000000000000000;
    WebDBGrid4.SetParentComponent(WebPanel5);
    WebDBGrid4.Name := 'WebDBGrid4';
    WebDBGrid4.Left := 30;
    WebDBGrid4.Top := 79;
    WebDBGrid4.Width := 643;
    WebDBGrid4.Height := 214;
    WebDBGrid4.Columns.Clear;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Numero';
      Title := 'Numero';
      Width := 150;
    end;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Nombre';
      Title := 'Nombre';
      Width := 250;
    end;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Puesto';
      Width := 100;
    end;
    with WebDBGrid4.Columns.Add do
    begin
      DataField := 'Depto';
      Title := 'Depto';
      Width := 100;
    end;
    WebDBGrid4.DataSource := DsEmpleados;
    WebDBGrid4.FixedCols := 0;
    WebDBGrid4.TabOrder := 0;
    WebDBGrid4.HeightPercent := 100.000000000000000000;
    WebDBGrid4.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid4, Self, 'OnDblClick', 'WebDBGrid4DblClick');
    WebDBGrid4.ColWidths[0] := 150;
    WebDBGrid4.ColWidths[1] := 250;
    WebDBGrid4.ColWidths[2] := 100;
    WebDBGrid4.ColWidths[3] := 100;
    WebDBGrid4.RowHeights[0] := 22;
    WebDBGrid4.RowHeights[1] := 22;
    WebDBGrid4.RowHeights[2] := 22;
    WebDBGrid4.RowHeights[3] := 22;
    WebDBGrid4.RowHeights[4] := 22;
    WebEdit10.SetParentComponent(WebPanel5);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 30;
    WebEdit10.Top := 46;
    WebEdit10.Width := 419;
    WebEdit10.Height := 22;
    WebEdit10.ChildOrder := 4;
    WebEdit10.HeightPercent := 100.000000000000000000;
    WebEdit10.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel5);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 467;
    WebSpeedButton4.Top := 44;
    WebSpeedButton4.Width := 100;
    WebSpeedButton4.Height := 24;
    WebSpeedButton4.Caption := 'Buscar';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('uRegEntEmp.WebPanel5.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton12.SetParentComponent(WebPanel5);
    WebSpeedButton12.Name := 'WebSpeedButton12';
    WebSpeedButton12.Left := 573;
    WebSpeedButton12.Top := 44;
    WebSpeedButton12.Width := 100;
    WebSpeedButton12.Height := 24;
    WebSpeedButton12.Caption := 'Cancelar';
    WebSpeedButton12.Color := clNone;
    WebSpeedButton12.Glyph.LoadFromFile('uRegEntEmp.WebPanel5.WebSpeedButton12.Glyph.png');
    WebSpeedButton12.HeightPercent := 100.000000000000000000;
    WebSpeedButton12.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton12, Self, 'OnClick', 'WebSpeedButton12Click');
    CEntrenaDoc.SetParentComponent(Self);
    CEntrenaDoc.Name := 'CEntrenaDoc';
    CEntrenaDoc.Active := False;
    SetEvent(CEntrenaDoc, Self, 'OnDataReceived', 'CEntrenaDocDataReceived');
    CEntrenaDoc.Left := 728;
    CEntrenaDoc.Top := 120;
    TEntrenaDoc.SetParentComponent(Self);
    TEntrenaDoc.Name := 'TEntrenaDoc';
    TEntrenaDoc.Connection := CEntrenaDoc;
    TEntrenaDoc.Left := 800;
    TEntrenaDoc.Top := 120;
    DsEntrenaDoc.SetParentComponent(Self);
    DsEntrenaDoc.Name := 'DsEntrenaDoc';
    DsEntrenaDoc.DataSet := TEntrenaDoc;
    DsEntrenaDoc.Left := 872;
    DsEntrenaDoc.Top := 120;
    CEntrenamientos.SetParentComponent(Self);
    CEntrenamientos.Name := 'CEntrenamientos';
    CEntrenamientos.Active := False;
    SetEvent(CEntrenamientos, Self, 'OnDataReceived', 'CEntrenamientosDataReceived');
    CEntrenamientos.Left := 728;
    CEntrenamientos.Top := 168;
    TEntrenamientos.SetParentComponent(Self);
    TEntrenamientos.Name := 'TEntrenamientos';
    TEntrenamientos.Connection := CEntrenamientos;
    TEntrenamientos.Left := 800;
    TEntrenamientos.Top := 168;
    DsEntrenamientos.SetParentComponent(Self);
    DsEntrenamientos.Name := 'DsEntrenamientos';
    DsEntrenamientos.DataSet := TEntrenamientos;
    DsEntrenamientos.Left := 872;
    DsEntrenamientos.Top := 168;
    CEmpleados.SetParentComponent(Self);
    CEmpleados.Name := 'CEmpleados';
    CEmpleados.Active := False;
    CEmpleados.Left := 720;
    CEmpleados.Top := 216;
    TEmpleados.SetParentComponent(Self);
    TEmpleados.Name := 'TEmpleados';
    TEmpleados.Connection := CEmpleados;
    TEmpleados.Left := 800;
    TEmpleados.Top := 216;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    SetEvent(WebHttpRequest1, Self, 'OnResponse', 'WebHttpRequest1Response');
    WebHttpRequest1.Left := 728;
    WebHttpRequest1.Top := 328;
    DsEmpleados.SetParentComponent(Self);
    DsEmpleados.Name := 'DsEmpleados';
    DsEmpleados.DataSet := TEmpleados;
    DsEmpleados.Left := 872;
    DsEmpleados.Top := 216;
    CEntrenamientosPT.SetParentComponent(Self);
    CEntrenamientosPT.Name := 'CEntrenamientosPT';
    CEntrenamientosPT.Active := False;
    CEntrenamientosPT.AfterConnect := CEntrenamientosPTAfterConnect;
    CEntrenamientosPT.Left := 728;
    CEntrenamientosPT.Top := 272;
    TEntrenamientosPT.SetParentComponent(Self);
    TEntrenamientosPT.Name := 'TEntrenamientosPT';
    TEntrenamientosPT.Connection := CEntrenamientosPT;
    TEntrenamientosPT.Left := 800;
    TEntrenamientosPT.Top := 272;
    DsEntrenamientosPT.SetParentComponent(Self);
    DsEntrenamientosPT.Name := 'DsEntrenamientosPT';
    DsEntrenamientosPT.DataSet := TEntrenamientosPT;
    DsEntrenamientosPT.Left := 872;
    DsEntrenamientosPT.Top := 272;
    CEmpPT.SetParentComponent(Self);
    CEmpPT.Name := 'CEmpPT';
    CEmpPT.Active := False;
    CEmpPT.AfterConnect := CEmpPTAfterConnect;
    CEmpPT.Left := 808;
    CEmpPT.Top := 328;
    TEmPT.SetParentComponent(Self);
    TEmPT.Name := 'TEmPT';
    TEmPT.Connection := CEmpPT;
    TEmPT.Left := 880;
    TEmPT.Top := 328;
  finally
    WebPanel6.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebListBox1.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebEdit7.AfterLoadDFMValues;
    WebEdit8.AfterLoadDFMValues;
    WebEdit9.AfterLoadDFMValues;
    WebDateTimePicker1.AfterLoadDFMValues;
    WebCheckBox1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebCalendar1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    WebDBGrid4.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton12.AfterLoadDFMValues;
    CEntrenaDoc.AfterLoadDFMValues;
    TEntrenaDoc.AfterLoadDFMValues;
    DsEntrenaDoc.AfterLoadDFMValues;
    CEntrenamientos.AfterLoadDFMValues;
    TEntrenamientos.AfterLoadDFMValues;
    DsEntrenamientos.AfterLoadDFMValues;
    CEmpleados.AfterLoadDFMValues;
    TEmpleados.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    DsEmpleados.AfterLoadDFMValues;
    CEntrenamientosPT.AfterLoadDFMValues;
    TEntrenamientosPT.AfterLoadDFMValues;
    DsEntrenamientosPT.AfterLoadDFMValues;
    CEmpPT.AfterLoadDFMValues;
    TEmPT.AfterLoadDFMValues;
  end;
end;

end.
